import { render, staticRenderFns } from "./FooterCopyRight.vue?vue&type=template&id=0f5d89fa&"
import script from "./FooterCopyRight.vue?vue&type=script&lang=js&"
export * from "./FooterCopyRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports